export default {
  accessToken: '',
  code:false,
  user:{
    id:'',
    name:'',
    numberId:'',
    email:'',
    password:'',
    email_verified_at:'',
    language:'',
    photoURL:require("@/assets/images/portrait/small/avatar-s-11.jpg")
  }
}
